import {Integer, useResponsivePropValue} from 'platform/foundation';

import {MAIN_TOPBAR_HEIGHT} from '@dms/shared';

/**
 * Height of the fixed app chrome above a sourcing page. Mobile and tablet render a second bar
 * (PageNavigationBar, same height as the top bar) below the top bar, so twice the offset has to
 * be subtracted from the viewport height.
 */
const PAGE_HEADER_HEIGHT_MOBILE = MAIN_TOPBAR_HEIGHT * 2;
const PAGE_HEADER_HEIGHT_DESKTOP = MAIN_TOPBAR_HEIGHT;

export function useSourcingPageHeaderHeight(): Integer {
  return useResponsivePropValue([
    PAGE_HEADER_HEIGHT_MOBILE,
    PAGE_HEADER_HEIGHT_MOBILE,
    PAGE_HEADER_HEIGHT_DESKTOP,
  ]);
}
